// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__34_HV","navText":"Navbar_navText__iAszR","navLogo":"Navbar_navLogo__1-bOE","imgLogo":"Navbar_imgLogo__2eG5e"};